import { CourseYear } from '../../models/interfaces/course_year.interface';

interface SectionWithYear {
  courseYearId?: string | null;
}

/**
 * FP courses only: returns a new array with sections grouped by academic
 * year (in `years` order), so same-year sections render contiguously.
 * Stable sort — for non-FP courses (`years` empty/undefined, every section's
 * `courseYearId` is null) this is a no-op that preserves the original order.
 * Shared between course-content.component.ts (admin editor) and
 * sidenav-course.component.ts (student navigation) so both agree on ordering.
 */
export const sortSectionsByYear = <T extends SectionWithYear>(sections: T[], years: CourseYear[] | undefined): T[] => {
  if (!years?.length || !sections.length) return sections;

  const yearOrder = new Map(years.map((year, index) => [year.courseYearId, index]));
  return [...sections].sort((a, b) => {
    const orderA = a.courseYearId ? (yearOrder.get(a.courseYearId) ?? Number.MAX_SAFE_INTEGER) : Number.MAX_SAFE_INTEGER;
    const orderB = b.courseYearId ? (yearOrder.get(b.courseYearId) ?? Number.MAX_SAFE_INTEGER) : Number.MAX_SAFE_INTEGER;
    return orderA - orderB;
  });
};
